import React from "react";
import {
  getMarketInsightsHeadingCopy,
} from "./marketInsightsVariant";
import { getMarketHeadingVariant } from "../../services/TradingMallService";
import ConditionalSubtext from "./conditionalSubtext";

export interface MarketInsightsHeadingContent {
    preMarketTitle: string;
    preMarketSubtext: string;
    postMarketTitle: string;
    postMarketSubtext: string;
    weekendTitle: string;
    weekendSubtext: string;
}

export interface MarketInsightsHeadingProps {
    content: MarketInsightsHeadingContent;
    className?: string;
}

export const MarketInsightsHeading = async ({ content, className }: MarketInsightsHeadingProps) => {
    const wrapperClassName = className ?? "";
    const variant = await getMarketHeadingVariant();

    const { title, subtext } = getMarketInsightsHeadingCopy(
      content,
      variant,
    );


    return (
        <div className={`${wrapperClassName} flex flex-col gap-[4px] md:px-[16px] md:py-[16px] px-[16px] py-[12px]`}>
            <h1 className="md:text-[20px] font-medium text-[#1a1a1a] text-[18px] ">
                {title}
            </h1>
            <ConditionalSubtext subtext={subtext} />
        </div>
    );
};

export default MarketInsightsHeading;